<template>
    <CList :pConfigList="ConfigList" :segurity="segurity">
	<template slot="bodyForm">
		<CLoader :pConfigLoad="ConfigLoad">
		<template slot="BodyFormLoad">
            <form id="FormAsignacion" role="form" method="post" autocomplete="off" onSubmit="return false">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                        <h3>Reasignación del personal de los eventos</h3>
                    </div>
                </div>

                <div class="row" v-show="HabilitaCambio==2">
                    <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                        <label class="col-form-label">Cambiar Por:</label>
                    </div>
                </div>

                <div class="row" v-show="HabilitaCambio==2">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-2 col-xl-2">
                        <div class="form-check">
                            <input type="radio" v-model="HabilitaCambio" @change="EjecutarBusqueda();" class="form-check-input" name="flexRadioDefault" id="flexRadioDefault1" value="1">
                            <label class="form-check-label" for="flexRadioDefault1">
                                Evento
                            </label>
                        </div>
                    </div>

                    <div class="col-12 col-sm-12 col-md-6 col-lg-2 col-xl-2">
                        <div class="form-check">
                            <input type="radio" v-model="HabilitaCambio" @change="EjecutarBusqueda();" class="form-check-input" name="flexRadioDefault" id="flexRadioDefault2" value="2">
                            <label class="form-check-label" for="flexRadioDefault2">
                                Personal
                            </label>
                        </div>
                    </div>
                </div>

                <div class="form-group row" v-show="HabilitaCambio!=''">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
                        <label class="col-form-label">Personal de Origen</label>
                        <select v-model="PersonalOrigen" @change="EjecutarBusqueda();" name="FormPersonal" class="form-control form-select">
                            <option value="0">Seleccione una opción</option>
                            <option v-for="(item,index) in ListaPersonalOr" :key="index" :value="item.IdUsuario">
                                {{item.NombreCompleto}}
                            </option>
                        </select>
                        <CValidation v-if="this.errorvalidacion.IdVendedorOrg" :Mensaje="'*'+errorvalidacion.IdVendedorOrg[0]"/>
                    </div>

                    <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
                        <label class="col-form-label">Personal de Destino</label>
                        <select v-model="PersonalDestino" name="FormPersonal" class="form-control form-select">
                            <option value="0">Seleccione una opción</option>
                            <option v-for="(item,index) in ListaPersonalDe" :key="index" :value="item.IdUsuario">
                                {{item.NombreCompleto}}
                            </option>
                        </select>
                        <CValidation v-if="this.errorvalidacion.IdVendedorDes" :Mensaje="'*'+errorvalidacion.IdVendedorDes[0]"/>
                    </div>
                </div>

                <div class="row" v-show="HabilitaCambio == 1">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
                        <div class="table-responsive pb-0">
                            <table class="table table-striped mb-0">
                                <thead>
                                    <tr>
                                        <th :class="StyleTh+' text-center'" width="3%">#</th>
                                        <th width="10%">
                                            <div class="form-check">
												<input type="checkbox" v-model="CheckTodos" class="form-check-input"  @change="MarcarTodos()" :disabled="(PersonalOrigen==0)?true:false" id="chkasig">
												<label :class="StyleTh+' form-check-label'" for="chkasig" style="margin-bottom:0 !important">
													Todos
												</label>
											</div>
                                        </th>
                                        <th :class="StyleTh" width="19%">Folio</th>
                                        <th :class="StyleTh" width="40%">Cliente</th>
                                        <th :class="StyleTh" width="23%">Empresa</th>
                                        <th :class="StyleTh" width="5%">*</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,index) in ListaEventos" :key="index">
                                        <td>{{(index+1)}}</td>
                                        <td>
                                            <div class="form-check">
												<input type="checkbox" v-model="ListaEventosAsign" class="form-check-input" :value="item" :id="'chkasig_'+index">
												<label class="form-check-label" :for="'chkasig_'+index">
													
												</label>
											</div>
                                        </td>
                                        <td><p :class="StyleTd">{{item.Folio}}</p></td>
                                        <td><p :class="StyleTd">{{item.Nombres}}</p></td>
                                        <td><p :class="StyleTd">{{item.Agente}}</p></td>
                                        <td>
                                            <button type="button" @click="AbrirModalResumen(item.IdCotizacion)" class="btn btn-link text-primary px-3 mb-0 mr-1">
                                                <i class="fas fa-eye text-primary me-2" aria-hidden="true"></i> Ver Detalle
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <CValidation v-if="this.errorvalidacion.ArregloEventos" :Mensaje="'*'+errorvalidacion.ArregloEventos[0]"/>
                    </div>
                </div>


                <div class="row mt-3" v-show="HabilitaCambio!=''">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                        <label class="col-form-label">Motivo del cambio:</label>
                        <textarea v-model="Motivo" class="form-control" rows="3"></textarea>
                        <CValidation v-if="this.errorvalidacion.Motivo" :Mensaje="'*'+errorvalidacion.Motivo[0]"/>
                    </div>
                </div>

                <div v-show="HabilitaCambio!=''">
                    <CBtnSave :poBtnSave="oBtnSave" />
                </div>

                <CModal :pConfigModal="ConfigModal2" :poBtnSave="oBtnSave2">
					<template slot="Form">
						<FormDetalle :poBtnSave="oBtnSave2"></FormDetalle>
					</template>
				</CModal>

            </form>
        </template>
		</CLoader>
	</template>
	</CList>
</template>

<script>

import moment from 'moment';
import FormDetalle from '@/views/modulos/crm/calendario/FormResumen.vue';

import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionAsignarPersonal';
const EmitEjecuta3 = 'seccionDetalleEventos';

export default {
    name: 'ListaCliente',
    props: ['sFiltros','pOrigen'],
    components: {
        FormDetalle,
    },
    data() {
        return {
            ConfigList:{
                Title: 'Reasignación del Personal',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                TitleFirst: '',
                ShowFiltros: false,
                ShowPaginador: false,
                TypeBody: 'Form',
				EmitSeccion: EmitEjecuta,
            },
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            oBtnSave:{
                toast: 0,
                IsModal: false,
                ShowBtnSave:false,
                DisableBtn: false,
                ReturnRoute: 'panelSubMenus',
                EmitSeccion: EmitEjecuta,
            },
            ConfigModal2:{
                ModalTitle: "Detalle Eventos",
                ModalNameId: 'ModalFormEv',
                EmitSeccion: EmitEjecuta3,
                ModalSize: 'lg',
                ShowFooter: false,
            },
            oBtnSave2: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta3,
            },
            segurity: {},
            errorvalidacion: [],
			Emit: EmitEjecuta,
            StyleTh: Configs.stylesTable.StyleTh+' text-green-black',
            StyleTd: Configs.stylesTable.StyleTd+'',
            HabilitaCambio: 1,
            ListaPersonalOr: [],
            ListaPersonalDe: [],
            ListaEventos: [],
            ListaEventosAsign: [],
            PersonalOrigen: 0,
            PersonalDestino: 0,
            CheckTodos: false,
            Motivo: '',
        }
    },
    methods: {
        async Guardar()
        {
            this.errorvalidacion = [];
            this.oBtnSave.Toast = 0; 
            this.oBtnSave.DisableBtn = true;

            let newObjeto = {
                IdVendedorOrg: this.PersonalOrigen,
				IdVendedorDes: this.PersonalDestino,
				Motivo: this.Motivo,
				ArregloEventos: this.ListaEventosAsign,
				Habilitado: this.HabilitaCambio,
            }
            
			await this.$http.post(
                'reAsignarMultiple',newObjeto
            ).then((res)=>{
                this.EjecutaConExito(res);
            }).catch(err=>{   
                this.EjecutaConError(err);
            });
        },
		EjecutaConExito(res)
        {
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.Motivo = '';
            this.EjecutarBusqueda();
        },
        EjecutaConError(err)
        {
            this.oBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("usersVentas",{
                params:{
                    TipoUsuario: 'US',
					Estatus: 'Activo',
                }
            }).then((res) => {
                let response = res.data.data;
                this.ListaPersonalOr = response;

                this.segurity = res.data.segurity;
                if(this.segurity.Save){
                    this.oBtnSave.ShowBtnSave = true;
                } else {
                    this.oBtnSave.ShowBtnSave = false;
                }
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Regresar() {
            this.$router.push({name:this.oBtnSave.ReturnRoute,params:{}});
        },
        EjecutarBusqueda()
        {
            this.errorvalidacion = [];
            this.ListaEventosAsign = [];
            this.CheckTodos = false;

            if(this.PersonalOrigen!=0)
            {
                this.PersonalDestino = 0;
                let Busqueda = this.PersonalOrigen;
                let newArray = this.ListaPersonalOr.filter(function(item,index){
                    if(Busqueda != item.IdUsuario){
                        return item;
                    }
                });

                this.ListaPersonalDe = newArray;
                this.ListaEventos = [];

                // SI ES POR EVENTO, ENTONCES LISTARA LOS EVENTOS Y TE PERMITIRA CAMBIAR DE EJECUTIVO, UNO O VARIOS EVENTOS
                if(this.HabilitaCambio == 1)
                {
                    this.ObtenerEventosDestino();
                }
            }
            else
            {
                this.ListaEventos = [];
                this.ListaPersonalDe = [];
                this.PersonalDestino = 0;
            }
        },
        async ObtenerEventosDestino()
        {
            this.ConfigLoad.ShowLoader = true;

            await this.$http.get("getEventosActivos",{
                params:{
                    IdUsuario: this.PersonalOrigen,
                }
            }).then((res) => {
                let response = res.data.data;
                this.ListaEventos = response;

            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        MarcarTodos()
        {
            if(this.CheckTodos)
            {
                let newArray = [];
                this.ListaEventos.map(function(element){
                    newArray.push(element);
                });


                this.ListaEventosAsign = newArray;
            }
            else{
                this.ListaEventosAsign = [];
            }
        },
        AbrirModalResumen(IdCotizacion)
        {
            this.bus.$emit('NewModal_'+EmitEjecuta3,IdCotizacion,{});
        },
    },
    created()
    {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }
        
        this.bus.$off('Save_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        //this.ConfigLoad.ShowLoader = false;
        this.Lista();
        this.bus.$on('Save_'+EmitEjecuta,()=>
        {
            this.Guardar();
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
